import { render, staticRenderFns } from "./PartnerReportDetailSideCard.vue?vue&type=template&id=ab2bc4e2&"
import script from "./PartnerReportDetailSideCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportDetailSideCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports